import { platformApi } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpsertIntelligenceItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (json) => {
      return json.code
        ? platformApi.patch(`intelligence/${json.code}`, { json }).json()
        : platformApi.post('intelligence', { json }).json();
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['intelligence'] }),
  });
}
